module.exports = __webpack_public_path__ + "static/media/Lang-tb-ico.d54606f7.svg";